const ListStyle = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        display: 'flex',
        boxShadow: '10px -10px 15px #FFFFFF, 10px 10px 10px rgba(174, 174, 192, 0.10)',
        border: 'solid 1px #ffffff',
        backgroundColor: '#F4F4F4',
        padding: '16px',
        margin: '0 0 12px',
        borderRadius: "19px",
    },
    secondRow: {
        display: 'flex',
        marginTop: "15px !important",
        alignItems: 'center !important',
        justifyContent: 'space-between'
    },
    svg: {
        marginRight: '14px',
    },
    empty: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#753cbe'
    },
    name: {
        fontSize: '14px',
        color: '#753cbe',
        fontWeight: 700,
    },
    diabetType: {
        color: '#3CC0C3',
        fontSize: "12px",
        fontWeight: 700,
    },
    lastVisit: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: 400,
        color: '#707070 ',
    },
    listWaiting: {
        fontSize: '16px',
        color: '#753cbe',
        paddingLeft: '23px',
        fontWeight: '600',
        textAlign: 'center',
        paddingTop: '10px',
        paddingBottom: '20px',
    },
    waiting: {
        width: '172px',
        height: '48px',
        boxShadow: '2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.15)',
        border: 'solid 1px #ffffff !important',
        backgroundColor: '#FFFFFF !important',
        borderRadius: '16px !important',
        fontSize: '14px !important',
        color: '#753cbe !important',
        fontWeight: '600 !important',
        textAlign: 'center',
    },
    endMessage: {
        fontSize: '16px ',
        color: '#753cbe ',
        fontWeight: '600 ',
        textAlign: 'center',
    },
    text: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#707070 ',
        marginTop: '4px',
    },
    date: {
        color: '#753cbe',
        marginLeft: "5px !important",
        letterSpacing: '0.5px'
    }
};
export default ListStyle;
